import { CompareSharp } from "@mui/icons-material";
import { Alert, Box, Button, Card, Grid, Input, Modal, ModalDialog, Stack, Typography } from "@mui/joy";
import axios from "axios";
import { RC4Drop } from "crypto-js";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { rpcPost } from "../rpc/rpc_helper";
import { v4 as uuidv4 } from 'uuid';


const plataformas = ["ENJOEI", "OLX"];

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function ScrapperDash() {
    var servidorUrl = useSelector((state) => state.rpc.servidorUrl)
    var token = useSelector((state) => state.auth.token)

    var [vitrine, setVitrine] = useState({})
    var [displayVitrine, setDisplayVitrine] = useState({
        aberto : false,
        query : "",
        plataforma : "",
        resultados : []
    })
    var [queries, setQueries] = useState([])

    var [form, setForm] = useState({
        salvando: false,
        valor: "",
        error: "",
    })

    const salvarQuery = async () => {
        console.log("Salvando")
        setForm({ ...form, error: "", salvando: true })
        var r = await rpcPost(servidorUrl, token, null, {
            action: "COMPRADOR_NOVA_QUERY_RPC",
            runNow: true,
            payload: JSON.stringify({
                query: form.valor
            })
        })

        if (r.status == 200) {
            if (r.data.success) {
                setForm({ ...form, error: "Salvo!", salvando: false })
                await loadQueries()
            } else {
                setForm({ ...form, error: r.data.payload, salvando: false })
            }
        } else {
            setForm({ ...form, error: "Erro ao tentar registrar query", salvando: false })
        }
        // console.log(r)
    }

    function novaVitrine(queryId, queryNome, relatorioId) {
        return {
            queryId,
            nome: queryNome,
            relatorioId,
            plataformas: plataformas.reduce((acc, cur) => {
                acc[cur] = {
                    nome: cur,
                    ultimaBusca: null,
                    resultados: []
                };
                return acc;
            }, {})
        }
    }

    const onlyLoadQuerys = async () => {
        var r = await rpcPost(servidorUrl, token, null, {
            action: "COMPRADOR_RETORNA_QUERIES_RPC",
            runNow: true,
            payload: ""
        });

        
        if (r.status == 200) {
            setQueries(r.data.payload.filter(p => p["deletedAt"] == null))
            return r.data.payload;
        }

        return false

    }
    const loadQueries = async () => {
        var r = await onlyLoadQuerys()

        if(r !== false) {

            for (var i = 0; i < r.length; i++) {
                const queryId = r[i].id;
                const valor = r[i].valor;
                const relatorioId = r[i].relatorioId;

                vitrine = novaVitrine(
                    queryId,
                    valor,
                    relatorioId
                )

                for (var j = 0; j < plataformas.length; j++) {
                    var re = await rpcPost(servidorUrl, token, null, {
                        action: "REL_DOWNLOAD_RELATORIO",
                        runNow: true,
                        payload: JSON.stringify({
                            "codigo": relatorioId + "-" + plataformas[j],
                            "tenantId": "c241f070-887a-45cc-98ad-6e79b0b59061"
                        })
                    })

                    // console.log(re)
                    if (re.status == 200) {
                                if(typeof(re.data.success) == "undefined") {
                                    const resultados = structuredClone(re.data);
                                    // console.log(resultados)
                                    const plat = plataformas[j];
                                    const p = {...vitrine.plataformas[plat], resultados : resultados}
                                    vitrine.plataformas[plat] = p
                                    // console.log(vitrine)
                                }
                   
                    }

                }

                const nVitrine = structuredClone(vitrine)
                setVitrine((prev) => ({...prev, [queryId] : nVitrine}))
            }
        }
    }

    const mostraVitrine = (query, plataforma, resultados) => {
        setDisplayVitrine((prev) => ({
            ...prev,
            query : query,
            plataforma : plataforma,
            resultados : resultados,
            aberto : true
        }))
    }

    const fechaDisplayVitrine = () => {
        setDisplayVitrine((prev) => ({...prev, aberto : false}))
    }

    const remove = async (queryId) => {
        console.log(queryId)
        var re = await rpcPost(servidorUrl, token, null, {
            action: "COMPRADOR_REMOVE_QUERY_RPC",
            runNow: true,
            payload: JSON.stringify({
                "queryId": queryId,
            })
        })

        // console.log(re)
        if (re.status == 200) {
            await onlyLoadQuerys()
        }
    }

    React.useEffect(() => {
        // search()
        loadQueries()
    }, []);

    // console.log(vitrine)
    return <Grid container sx={{ p: 1 }} spacing={1}>
        <Grid xs={12}>
            <Stack direction="row" spacing={1}>
                <Input type="text" placeholder="Query..." onChange={(a) => setForm({ ...form, valor: a.target.value })} disabled={form.salvando} />
                <Button color="primary" onClick={salvarQuery} disabled={form.salvando}> Adicionar </Button>
                <Alert color="danger">{form.error}</Alert>
            </Stack>
        </Grid>
        <Modal open={displayVitrine.aberto} onClose={fechaDisplayVitrine}>
            <ModalDialog
                aria-labelledby="basic-modal-dialog-title"
                aria-describedby="basic-modal-dialog-description"
                sx={{ minWidth: 1080 }}
            >
                <Grid container sx={{overflowY: "auto", overflowX: "hidden"}}>
                    <Grid xs={12}>
                        <b>{displayVitrine["query"]}</b> - {displayVitrine.plataforma} ({displayVitrine.resultados.length})
                    </Grid>
                    <Grid xs={12}>
                            <Grid container spacing={1}>
                                {displayVitrine.resultados.map(e => {
                                    return <Grid key={uuidv4()} sx={{ width: "200px" }}>
                                        <Card>
                                            <Stack spacing={1}>
                                                <img src={e.image} referrerpolicy="no-referrer" />
                                                <Box>
                                                    <Stack direction="row" spacing={1}>
                                                        {/* fe82a50e-logo_olx.png */}
                                                        {e.platform == "ENJOEI" && <img src={servidorUrl + "/api/public/imgur/264a8c0e-logo_enjoei.png"} height={"40px"} />}
                                                        {e.platform == "OLX" && <img src={servidorUrl + "/api/public/imgur/fe82a50e-logo_olx.png"} height={"40px"} />}

                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                height: '40px', // ou qualquer altura desejada
                                                            }}
                                                        >
                                                            <Typography sx={{ fontSize: "12px" }}>{e.price}</Typography>
                                                        </Box>
                                                    </Stack>
                                                </Box>
                                                <Link to={e.link} target="_blank">
                                                    <Typography sx={{ fontSize: "12px" }}>{e.title}</Typography>
                                                </Link>
                                                <Stack spacing={1}>
                                                    {/* <pre>{JSON.stringify(e, null, 2)}</pre> */}
                                                    {/* <Typography>{e.title}</Typography>
                        <Typography>R$ {e.title}</Typography> */}
                                                </Stack>
                                            </Stack>
                                        </Card>
                                    </Grid>
                                })}
                             </Grid>
                         </Grid>
                           <Grid xs={12}>
                        <b>{displayVitrine["query"]}</b> - {displayVitrine.plataforma} ({displayVitrine.resultados.length})
                    </Grid>
                </Grid>
            </ModalDialog>
        </Modal>

        {queries.map(q => {
            return <Grid xs={12} key={q.id}>
                <Stack spacing={1}>
                    <Stack className="onHover" direction="row" spacing={1} alignItems="center" >
                        <Typography style={{ fontWeight: "bold" }}>{q.valor.toUpperCase()}</Typography>
                        {typeof(vitrine[q.id]) == "undefined" && <Typography>Carregando...</Typography>}
                        {typeof(vitrine[q.id]) != "undefined" && plataformas.map(p => {
                            const total = vitrine[q.id].plataformas[p].resultados.length

                            return total == 0 ? <Typography key={uuidv4()}>{p} <b>({total})</b></Typography> : 
                            <Link onClick={() => mostraVitrine(
                                q.valor,
                                p,
                                vitrine[q.id].plataformas[p].resultados
                            )}>{p} <b>({total})</b></Link>
                        })}
                        {typeof(vitrine[q.id]) != "undefined" && <Link onClick={() => remove(q.id)} color="danger" size="sm" className="hideble">Remover</Link>}
                    </Stack>
                    
                </Stack>
            </Grid>
        })}

    </Grid>
}

export default ScrapperDash

// <Grid container spacing={1}>
//                         {/* <pre>{r.res.length > 0 && JSON.stringify(r.res[0], null, 2)}</pre> */}
                       
//                     </Grid>